export const data = {
    datasets: [{
        type: 'bar',
        label: 'UnitChair',
        stack: 'combined',
    }, {
        type: 'bar',
        label: 'CT매매',
        stack: 'combined',
    }, {
        type: 'bar',
        label: 'CADCAM',
        stack: 'combined',
    }, {
        type: 'bar',
        label: '서비스로봇',
        stack: 'combined',
    }],
    labels: ['장비']
};

export const options = {
    type: 'bar',
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
        intersect: false,
    },
    scales: {
        x: {
            stacked: true,
        },
        y: {
            stacked: true
        }
    },
    plugins: {
        datalabels: {
            formatter: function(value, context) {
                let total = 0;
                context.chart.data.datasets.map(i=>{
                    total += i.data[0]
                })

                return `${(value / 100000000).toFixed(2) + " 억원"} (${(value/total*100).toFixed(1) }%)`;
            }
        },
    },
    onHover: (event, chartElement) => {
        event.native.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
    }
    
}
